/*
 * @Descripttion:
 * @Author: baiyang
 * @Date: 2022-02-23 11:11:42
 * @LastEditors: baiyang
 * @LastEditTime: 2022-03-09 11:28:41
 */
import {AD_TYPE} from '../../utils/constant'

Component({
  /**
   * 组件的属性列表
   */
  properties: {
    listAd: {
      type: Object,
      value: {
        type: AD_TYPE.WX_SYNTHESIZE_LIST,
        buttonName: '点击领取',
        mainTitle: '主标题',
        subtitle: '副标题',
        logo: ''
      }
    },
    bannerAd: {
      type: Object,
      value: {
        type: AD_TYPE.WX_SYNTHESIZE_BANNER,
        bannnerImg: ''
      }
    },
    popAd: {
      type: Object,
      value: {
        type: AD_TYPE.WX_SYNTHESIZE_POP,
        popImg: ''
      }
    },
    money: {
      type: Number,
      value: 0
    },
    haveNavBar: {
      type: Boolean,
      value: false
    }
  },
  /**
   * 组件的初始数据
   */
  data: {
    isShowPop: true
  },

  /**
   * 组件的方法列表
   */
  methods: {
    /**
     * @function 关闭弹窗
     * @author by
     */
    closePop() {
      this.setData({
        isShowPop: false
      })
    },
    /**
     * @function 点击广告
     * @author by
     */
    clickAd(e) {
      this.triggerEvent('adClick', e.currentTarget.dataset.type)
      this.setData({
        isShowPop: false
      })
    }
  }
})
